import { FC, useState } from 'react';
import { TableBody as Body } from '@mui/material';

import { CustomAlert, TableNoData } from '../../../../shared/uiComponents';
import { CustomTableRow, RowTableCell } from '../../../../shared/uiComponents/Table/tableHelpers';
import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';
import { programHeaders } from '../constants/programHeaders';
import { SkillAcquisitionProgramActions } from './SkillAreas/Components/SkillAccordionItemActions';
import { AdminTypes } from '../../../../components/Menu';
import Targets from './Targets';

import { useSelector } from '../../../../redux/store';
import { ProgramDataProperties } from '../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { Puzzle } from '../../../../shared/Assets/menuIcons';

interface ProgramRowRendererProperties {
	data: ProgramDataProperties[];
}

export const ProgramHeaders: HeaderProperties[] = [
	{ id: '5', name: 'Program name' },
	{ id: '1', name: 'Open targets' },
	{ id: '2', name: 'Mastered targets' },
	{ id: '3', name: 'Total targets' },
	{ id: '4', name: 'Actions' },
];

export const ProgramHeadersBT: HeaderProperties[] = [
	{ id: '4', name: 'Program name' },
	{ id: '1', name: 'Open targets' },
	{ id: '2', name: 'Mastered targets' },
	{ id: '3', name: 'Total targets' },
];

const Row = ({ row }: { row: ProgramDataProperties }) => {
	const role = useSelector((state) => state.account.role);
	const isBT = role?.section.id === AdminTypes.bt;

	const [open, setOpen] = useState<boolean>(false);

	const openHandler = () => setOpen(true);
	const closeHandler = () => setOpen(false);

	return (
		<>
			<CustomTableRow key={row.id}>
				<RowTableCell style={{ cursor: 'pointer' }} onClick={openHandler}>
					{row.name}
				</RowTableCell>
				<RowTableCell>{row.openTargets}</RowTableCell>
				<RowTableCell>{row.masteredTargets}</RowTableCell>
				<RowTableCell>{row.totalTargets}</RowTableCell>
				{!isBT && (
					<RowTableCell>
						<SkillAcquisitionProgramActions data={row} />
					</RowTableCell>
				)}
			</CustomTableRow>
			<CustomAlert
				title={row.name}
				open={open}
				onClose={closeHandler}
				Content={() => <Targets programId={row.id} />}
				maxWidth="lg"
				Icon={Puzzle}
			/>
		</>
	);
};

export const ProgramTableBody: FC<ProgramRowRendererProperties> = ({ data }) => {
	if (!data?.length) {
		return <TableNoData spanScope={programHeaders.length} />;
	}

	return (
		<Body>
			{data.map((row) => (
				<Row row={row} key={row.id} />
			))}
		</Body>
	);
};
